/**
 * 接続ステータス
 */
export var ConnectionStatuses;

(function (ConnectionStatuses) {
  /**
   * 未接続
   */
  ConnectionStatuses[ConnectionStatuses["Disconnected"] = 0] = "Disconnected";
  /**
   * 接続済
   */

  ConnectionStatuses[ConnectionStatuses["Connected"] = 1] = "Connected";
  /**
   * 接続エラー
   */

  ConnectionStatuses[ConnectionStatuses["Error"] = 2] = "Error";
})(ConnectionStatuses || (ConnectionStatuses = {}));